import { OctahedronGeometry, MeshPhongMaterial, Color } from 'three';
import InstancedShapes, { scatter } from './InstancedShapes.js';
import gsap from 'gsap';

let genHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

export default class Diamonds extends InstancedShapes {
    constructor(amount, repulsion) {
        super(
            new OctahedronGeometry(0.2),
            new MeshPhongMaterial(),
            amount,
            repulsion
        );
        this.place(scatter(10, 1.5)); // 1.25

        // Per-instance random colour, which used to be a material per diamond.
        // setColorAt is enough on its own - the fragment prefix defines
        // USE_COLOR whenever instanceColor is present, so no vertexColors flag
        // and no colour attribute are needed.
        const color = new Color();
        for (let i = 0; i < amount; i++) {
            this.mesh.setColorAt(i, color.set("#" + genHex(6)));
        }
        this.mesh.instanceColor.needsUpdate = true;

        gsap.from(this.positions, {
            x: Math.cos(this.isMobile ? 5.2 : 11),
            y: Math.sin(this.isMobile ? 5.2 : 11),
            z: Math.sin(this.isMobile ? 5.2 : 11),
            duration: 12.5,
            yoyo: true,
            repeat: -1,
            stagger: 0.01,
            ease: "back.inOut(1.7)",
            repeatDelay: 8,
            // delay: 12
        });
        gsap.from(this.rotations, {
            x: Math.PI * 6,
            duration: 30,
            yoyo: true,
            repeat: -1,
            ease: "power1.inOut()",
        });
    }
}
